import React, { useEffect, useState } from "react";
import { X } from "lucide-react";
import { api } from "../lib/api";

const readClosed = () => {
  try { return JSON.parse(sessionStorage.getItem("afg_closed_banners") || "[]"); } catch { return []; }
};

export function PromoBanner({ placement }) {
  const [banners, setBanners] = useState([]);
  const [closed, setClosed] = useState(readClosed);

  useEffect(() => {
    api.get(`/banners?placement=${placement}`).then((r) => setBanners(r.data || [])).catch(() => {});
  }, [placement]);

  const close = (id) => {
    const next = [...closed, id];
    setClosed(next);
    sessionStorage.setItem("afg_closed_banners", JSON.stringify(next));
  };

  const visible = banners.filter((b) => !closed.includes(b.id));
  if (!visible.length) return null;

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-5 space-y-3" data-testid={`banners-${placement}`}>
      {visible.map((b) => {
        const img = <img src={b.image} alt={b.title || "Promotion"} className="w-full h-full object-cover" />;
        return (
          <div key={b.id} className="relative rounded-2xl overflow-hidden border border-[#0D530E]/10 shadow-sm" data-testid={`banner-${b.id}`}>
            {b.link
              ? <a href={b.link} className="block aspect-[1200/260] bg-[#E7E1B1]">{img}</a>
              : <div className="aspect-[1200/260] bg-[#E7E1B1]">{img}</div>}
            <button onClick={() => close(b.id)} data-testid={`banner-close-${b.id}`} aria-label="Dismiss banner"
              className="absolute top-2.5 right-2.5 w-8 h-8 rounded-full bg-black/40 hover:bg-black/60 text-white flex items-center justify-center"
              style={{ transition: "background-color 0.2s ease" }}>
              <X size={16} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
